import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { toast } from "react-toastify";
import { returnPercentageFormatted } from "../../../../../lib/globalFormatterHelper";

import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";
import { caluclatePercentageQuoteSizeER } from "../actionSummaryColDefHelperFunctions";
import { updateQuotesAcrossTables } from "@/store/tradeDataStoreACTIONS";
import tradeDataStore from "@/store/tradeDataStore";
import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { useTheme } from "next-themes";
const DynamicCellEditorQuoteSizeExecutionRequest = forwardRef(
  (params: any, ref) => {
    const { theme } = useTheme();
    const inputRef = useRef<HTMLInputElement>(null);
    const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);

    const currentTradeData = tradeDataStore((state) => state.tradeData);
    // ONLY USED ON RP.
    const thisTrade = currentTradeData.find(
      (trade) => trade.esid == fullTradeData.esid,
    );

    const [value, setValue] = useState(params.value);

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, []);

    const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
      const input = event.target.value;
      // Update the value once validation has passed
      if (input[input.length - 1] == "-") {
        return;
      }
      setValue(input);
    };

    const validateAndSave = () => {
      // Check final input matches an approprate pattern.
      if (value > 100 || value < 1) {
        if (value > 100) {
          toast(
            "Unable to set quote size larger than 100%. Quoted size set back to default.",
          );
        }
        if (value < 1) {
          toast(
            "Unable to set quote size below 1%. Quoted size set back to default.",
          );
        }
        const newParams = { data: { ...thisTrade } };
        newParams.data.quotedSize = caluclatePercentageQuoteSizeER(params);

        if (!newParams.data.legs) {
          return;
        }
        newParams.data.legs.forEach((leg: any) => {
          leg.quotedSize = (leg.notionalLeg1 * 100) / 100;
        });
        // params.data.quotedSize = params.newValue;
        updateQuotesAcrossTables(newParams);
        return;
      }

      const newParams = { data: { ...thisTrade } };
      newParams.data.quotedSize = value;
      if (!newParams.data.legs) {
        return;
      }
      newParams.data.legs.forEach((leg: any) => {
        if (leg.instrumentType == InstrumentTypeCode.FUT) {
          leg.quotedSize = Math.round(leg.notionalLeg1 * (value / 100));
        } else leg.quotedSize = Math.round(leg.notionalLeg1 * (value / 100));
      });
      // params.data.quotedSize = params.newValue;
      updateQuotesAcrossTables(newParams);
      return;
      // return parseInt(value);
    };

    useImperativeHandle(ref, () => ({
      getValue: () => validateAndSave(), // Preserve only fully valid values
    }));

    return (
      <input
        //   id="quoteInputEditor"
        ref={inputRef}
        type="number"
        value={returnPercentageFormatted(value)}
        onChange={handleInput} // Blocks unwanted characters immediately
        className={`${
        theme === "light" ? "inputCellLight" : "inputCellDark"
      } ag-input ag-roundedInputStyle w-full justify-center !border-none text-center`}
      />
    );
  },
);

export default DynamicCellEditorQuoteSizeExecutionRequest;
